export const filterOptions = (value) => (options) => {
  return options.filter((option) => option.value === value)
}

export const filterOptionsByLabel = value => options => {
  return options.filter(option => option.label === value);
}
